import { clamp01 } from "../../utils/clamp";

interface DialProps {
  label: string;
  emoji: string;
  value: number;
  onChange: (value: number) => void;
  step?: number;
}

export function Dial({ label, emoji, value, onChange, step = 0.1 }: DialProps) {
  const percent = Math.round(clamp01(value) * 100);
  const bump = (delta: number) => onChange(clamp01(value + delta));

  return (
    <div className="dial" aria-label={label}>
      <div className="dial-face">
        <div
          className="dial-arc"
          style={
            {
              ["--dial-percent" as string]: `${percent}%`,
            } as React.CSSProperties
          }
          role="meter"
          aria-label={`${label} level`}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={percent}
        >
          <div className="dial-face-inner">
            <span className="dial-emoji" aria-hidden="true">
              {emoji}
            </span>
            <span className="dial-value">{percent}</span>
          </div>
        </div>
      </div>
      <div className="dial-controls">
        <button
          type="button"
          className="dial-button"
          onClick={() => bump(-step)}
          aria-label={`Decrease ${label}`}
        >
          −
        </button>
        <span className="dial-label">{label}</span>
        <button
          type="button"
          className="dial-button"
          onClick={() => bump(step)}
          aria-label={`Increase ${label}`}
        >
          +
        </button>
      </div>
    </div>
  );
}
